// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

const dropdownRegistry = new Set()
const commandButtons = new WeakSet()

const cleanupDropdowns = () => {
  dropdownRegistry.forEach((entry) => {
    entry.setOpen(false)
    entry.trigger.removeEventListener("click", entry.onTriggerClick)
    document.removeEventListener("click", entry.onDocumentClick)
  })
  dropdownRegistry.clear()
}

const initDropdowns = () => {
  document.querySelectorAll("el-dropdown").forEach((dropdown) => {
    if (dropdown.dataset.dropdownInitialized === "true") return

    const trigger = dropdown.querySelector("button")
    const menu = dropdown.querySelector("el-menu")

    if (!trigger || !menu) return

    dropdown.dataset.dropdownInitialized = "true"

    menu.hidden = true
    menu.dataset.state = "closed"
    trigger.setAttribute("aria-haspopup", "menu")
    trigger.setAttribute("aria-expanded", "false")

    const entry = {
      dropdown,
      trigger,
      menu,
      open: false,
      setOpen: () => {},
      onTriggerClick: () => {},
      onDocumentClick: () => {},
    }

    entry.setOpen = (value) => {
      entry.open = value
      trigger.setAttribute("aria-expanded", value ? "true" : "false")
      if (value) {
        menu.hidden = false
        menu.dataset.state = "open"
      } else {
        menu.hidden = true
        menu.dataset.state = "closed"
      }
    }

    entry.onTriggerClick = (event) => {
      event.preventDefault()
      event.stopPropagation()
      entry.setOpen(!entry.open)
    }

    entry.onDocumentClick = (event) => {
      if (!dropdown.contains(event.target)) {
        entry.setOpen(false)
      }
    }

    trigger.addEventListener("click", entry.onTriggerClick)
    document.addEventListener("click", entry.onDocumentClick)

    dropdown.addEventListener("keyup", (event) => {
      if (event.key === "Escape") {
        entry.setOpen(false)
        trigger.focus()
      }
    })

    menu.querySelectorAll("a, button").forEach((element) => {
      element.addEventListener("click", () => entry.setOpen(false))
    })

    dropdownRegistry.add(entry)
  })
}

const initCommandToggles = () => {
  document.querySelectorAll('button[command="--toggle"][commandfor]').forEach((button) => {
    if (commandButtons.has(button)) return
    commandButtons.add(button)

    const targetId = button.getAttribute("commandfor")
    if (!targetId) return

    const target = document.getElementById(targetId)
    if (!target) return

    const setState = (open) => {
      if (open) {
        target.removeAttribute("hidden")
        target.dataset.state = "open"
      } else {
        target.setAttribute("hidden", "")
        target.dataset.state = "closed"
      }
      button.setAttribute("aria-expanded", open ? "true" : "false")
    }

    setState(!target.hasAttribute("hidden"))

    button.addEventListener("click", (event) => {
      event.preventDefault()
      const open = target.hasAttribute("hidden")
      setState(open)
    })

    target.querySelectorAll("a, button").forEach((element) => {
      element.addEventListener("click", () => setState(false))
    })
  })
}

const initNavbar = () => {
  initCommandToggles()
  initDropdowns()
}

document.addEventListener("turbo:load", initNavbar)
document.addEventListener("turbo:before-cache", () => {
  cleanupDropdowns()
  document.querySelectorAll('el-disclosure[id]').forEach((disclosure) => {
    disclosure.setAttribute("hidden", "")
    disclosure.dataset.state = "closed"
  })
})

import "trix"
import "@rails/actiontext"
